(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruta-campaign-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ruta-campaign-slideshow')) {
    customElements.define('ruta-campaign-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = [...this.querySelectorAll('.ruta-campaign__slide')];
        this.dots = [...this.querySelectorAll('[data-slide]')];
        this.index = 0;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.hovered = false;
        this.focused = false;
        this.inView = true;
        this.pauseButton = this.querySelector('[data-pause]');
        if (this.slides.length < 2) return;
        this.querySelector('.ruta-campaign__controls').hidden = false;
        this.addEventListener('click', event => {
          const control = event.target.closest('button');
          if (!control) return;
          if (control.hasAttribute('data-pause')) {
            this.paused = !this.paused;
            this.updatePause();
          } else if (control.hasAttribute('data-slide')) {
            this.show(Number(control.dataset.slide), true);
          } else if (control.hasAttribute('data-direction')) {
            this.show(this.index + Number(control.dataset.direction), true);
          }
          this.schedule();
        }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault(); this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1), true); this.schedule();
        }, options);
        this.addEventListener('touchstart', event => { this.touchX = event.changedTouches[0].clientX; this.touchY = event.changedTouches[0].clientY; }, {...options, passive:true});
        this.addEventListener('touchend', event => {
          const dx = event.changedTouches[0].clientX - this.touchX;
          const dy = event.changedTouches[0].clientY - this.touchY;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { this.show(this.index + (dx < 0 ? 1 : -1), true); this.schedule(); }
        }, {...options, passive:true});
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.updatePause(); this.schedule(); }, options);
        document.addEventListener('shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide.contains(event.target));
          if (selected >= 0) { this.paused = true; this.show(selected, false); this.updatePause(); this.schedule(); }
        }, options);
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
        this.updatePause(); this.schedule();
      }
      updatePause() { this.pauseButton.textContent = this.paused ? 'Play' : 'Pause'; this.pauseButton.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow'); }
      show(index, manual) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { const active = i === this.index; slide.classList.toggle('is-active', active); slide.inert = !active; slide.setAttribute('aria-hidden', String(!active)); this.dots[i].setAttribute('aria-current', String(active)); });
        if (manual) this.querySelector('[data-status]').textContent = 'Slide ' + (this.index + 1) + ' of ' + this.slides.length;
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || this.hovered || this.focused || !this.inView || document.hidden) return;
        this.timer = setTimeout(() => { this.show(this.index + 1, false); this.schedule(); }, Number(this.dataset.interval) || 5000);
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruta-evidence-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ruta-evidence-landing')) {
    customElements.define('ruta-evidence-landing', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('.rel__form');
        if (!form) return;
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = form.querySelector('button[type="submit"]');
          const error = form.querySelector('.rel__error');
          if (button.disabled) return;
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          error.hidden = true;
          const data = new FormData(form);
          const plan = data.get('selling_plan');
          if (!plan) data.delete('selling_plan');
          data.delete('return_to');
          try {
            const response = await fetch(this.dataset.addUrl, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message);
            const destination = this.dataset.welcome === 'true' && !plan ? `/discount/WELCOME10?redirect=${encodeURIComponent(this.dataset.cartUrl)}` : this.dataset.cartUrl;
            window.location.assign(destination);
          } catch (failure) {
            error.textContent = failure.message || this.dataset.error;
            error.hidden = false;
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruta-hydration"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ruta-hydration')) {
  customElements.define('ruta-hydration', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const tabs = this.querySelector('[data-flavor-tabs]');
      const buttons = [...this.querySelectorAll('[data-flavor]')];
      const panels = [...this.querySelectorAll('[data-panel]')];
      if (!tabs || !buttons.length) return;
      tabs.hidden = false;
      tabs.setAttribute('role', 'tablist');
      buttons.forEach(button => button.setAttribute('role', 'tab'));
      panels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', buttons.find(button => button.dataset.flavor === panel.dataset.panel).id);
        panel.tabIndex = 0;
      });
      const select = (index, focus = false) => {
        buttons.forEach((button, i) => { button.setAttribute('aria-selected', String(i === index)); button.tabIndex = i === index ? 0 : -1; });
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
        if (focus) buttons[index].focus();
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(index));
        button.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          else if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = buttons.length - 1;
          else return;
          event.preventDefault(); select(next, true);
        });
      });
      select(0);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
